module.exports = __webpack_public_path__ + "media/Audio15_k.0a0b863d.wav";